import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary:    { main: '#00BFA5', light: '#5df2d6', dark: '#008c75' },
    secondary:  { main: '#FFB300', light: '#ffe54c', dark: '#c68400' },
    error:      { main: '#FF5252' },
    warning:    { main: '#FF9800' },
    success:    { main: '#69F0AE' },
    info:       { main: '#40C4FF' },
    background: { default: '#0A0F1E', paper: '#111827' },
    text:       { primary: '#E8F5E9', secondary: '#B0BEC5' },
  },
  typography: {
    fontFamily: '"IBM Plex Sans", "Roboto", sans-serif',
    fontSize: 15,
    h1: { fontFamily: '"IBM Plex Mono", monospace', fontWeight: 700, fontSize: '2.4rem' },
    h2: { fontFamily: '"IBM Plex Mono", monospace', fontWeight: 700, fontSize: '2rem' },
    h3: { fontFamily: '"IBM Plex Mono", monospace', fontWeight: 600, fontSize: '1.75rem' },
    h4: { fontFamily: '"IBM Plex Mono", monospace', fontWeight: 600, fontSize: '1.5rem' },
    h5: { fontFamily: '"IBM Plex Sans", sans-serif', fontWeight: 700, fontSize: '1.35rem' },
    h6: { fontFamily: '"IBM Plex Sans", sans-serif', fontWeight: 700, fontSize: '1.15rem' },
    subtitle1: { fontSize: '1.05rem', fontWeight: 600 },
    subtitle2: { fontSize: '0.95rem', fontWeight: 600 },
    body1:     { fontSize: '1rem',    lineHeight: 1.7 },
    body2:     { fontSize: '0.9rem',  lineHeight: 1.6 },
    caption:   { fontSize: '0.82rem', lineHeight: 1.5 },
    overline:  { fontSize: '0.75rem', letterSpacing: '0.1em' },
    button:    { fontSize: '0.9rem',  fontWeight: 600, textTransform: 'none' },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: '#111827',
          border: '1px solid rgba(0,191,165,0.12)',
          transition: 'border-color 0.2s, box-shadow 0.2s',
          '&:hover': {
            borderColor: 'rgba(0,191,165,0.3)',
            boxShadow:   '0 0 20px rgba(0,191,165,0.08)',
          }
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: { padding: '20px' }
      }
    },
    MuiChip: {
      styleOverrides: {
        root:  { fontFamily: '"IBM Plex Mono", monospace', fontSize: '0.82rem', height: 28 },
        sizeSmall: { fontSize: '0.78rem', height: 24 },
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& th': {
            backgroundColor: '#0d1a2e',
            fontFamily:      '"IBM Plex Mono", monospace',
            fontSize:        '0.82rem',
            letterSpacing:   '0.08em',
            textTransform:   'uppercase',
            color:           '#00BFA5',
            padding:         '12px 16px',
          }
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: { fontSize: '0.9rem', padding: '10px 16px' },
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: { '& td': { fontSize: '0.9rem' } }
      }
    },
    MuiButton: {
      styleOverrides: {
        root:           { fontSize: '0.9rem', padding: '8px 18px', borderRadius: 8 },
        sizeSmall:      { fontSize: '0.82rem', padding: '5px 12px' },
        sizeLarge:      { fontSize: '1rem', padding: '10px 24px' },
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root:  { fontSize: '0.95rem' },
        input: { fontSize: '0.95rem' },
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: { fontSize: '0.92rem' },
      }
    },
    MuiSelect: {
      styleOverrides: {
        select: { fontSize: '0.92rem' },
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: { fontSize: '0.92rem', minHeight: 40 },
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: { fontSize: '0.85rem' },
      }
    },
    MuiTab: {
      styleOverrides: {
        root: { fontSize: '0.88rem', fontWeight: 600, minHeight: 46 },
      }
    },
    MuiListItemText: {
      styleOverrides: {
        primary:   { fontSize: '0.95rem' },
        secondary: { fontSize: '0.82rem' },
      }
    },
    MuiAlert: {
      styleOverrides: {
        message: { fontSize: '0.92rem' },
      }
    },
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          h1: 'h1', h2: 'h2', h3: 'h3',
          h4: 'h4', h5: 'h5', h6: 'h6',
        }
      }
    }
  }
});

export default theme;
